import { SoundManager } from './core/soundManager';
import { EventName } from './events/eventsName';
import { GameEvent } from './events/gameEvent';
import { Store } from './store/gameStore';

export function registerCustomEvents() {
    GameEvent.add(EventName.TOGGLE_SOUND, toggleSound);
    GameEvent.add(EventName.TOGGLE_AUTOCOMPLETE, toggleAutocomplete);
    GameEvent.add(EventName.TOGGLE_LEFT_HANDED, toggleLeftHanded);
    GameEvent.add(EventName.TOGGLE_CARD_HIGHLIGHTING, toggleCardHighlighting);
    GameEvent.add(EventName.TOGGLE_AUTOPLAY, toggleAutoPlay);
}

function toggleSound(): void {
    const isSoundOn = Store.toggleSound();
    SoundManager.mute(!isSoundOn); //Store.soundOn = true is muted => false,
}

function toggleAutocomplete() {
    Store.toggleAutocomplete();
    GameEvent.emit(EventName.REFRESH);
}
function toggleLeftHanded() {
    Store.toggleLeftHanded();
    GameEvent.emit(EventName.REFRESH);
}
function toggleCardHighlighting() {
    Store.toggleCardHighlighting();
    GameEvent.emit(EventName.REFRESH);
}
function toggleAutoPlay() {
    Store.toggleAutoPlay();
    GameEvent.emit(EventName.REFRESH);
}
